(function () {
    'use strict';

    angular.module("imApp").factory("consignmentSplitEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1450,
                    parameters: parms || {}
                });
            },
            listPlans: function (parms) {
                return $ihttp.post({
                    method: 1451,
                    parameters: parms || {}
                });
            },
            listSplitEdits: function (parms) {
                return $ihttp.post({
                    method: 1449,
                    parameters: parms || {}
                });
            },
            moveLine: function (mergeObj) {
                return $ihttp.post({
                    method: 1452,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
